/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';
import { CONF_API_BASEURL } from '../../../config';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> 'Pressreleases' --------------------------------
    pressreleases: [],
    pressreleasesheadlines: [],
};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Website' - 'Pressreleases'
    ***************************************************************************/
    /***************************************************************************
    * get_Pressreleases()
    *
    * Desc: Return 'Pressreleases'.
    * Note:
    *
    */
    get_Pressreleases: state => {

        return state.pressreleases;

    }, // eof get_Pressreleases()


    /***************************************************************************
    * get_Pressreleases_Filtered()
    *
    * Desc: .
    * Note: Checks 'if Pressreleses is active'.
    *
    */
    get_Pressreleases_Filtered: state => {

        return state.pressreleases.filter(x => x.active === true).sort((a, b) => {
            return a.publishDate > b.publishDate ? -1 : 1;
        });

    }, // eof get_Pressreleases_Filtered()


    /***************************************************************************
    * get_PressreleasesHeadlines_Filtered()
    *
    * Desc: .
    * Note: Checks 'if Pressreleses is active'.
    *
    */
    get_PressreleasesHeadlines_Filtered: state => {

        return state.pressreleasesheadlines.filter(x => x.active === true).sort((a, b) => {
            return a.publishDate > b.publishDate ? -1 : 1;
        });

    }, // eof get_PressreleasesHeadlines_Filtered()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Website' - 'Pressreleases'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getPressreleases()
    *
    * Desc: Save 'Pressreleases' to state.
    * Note:
    *
    */
    mut_call_getPressreleases: (state, payload) => {

        let pressreleases = [...payload.pressreleases];


        state.pressreleases = pressreleases;

    }, // eo function mut_call_getPressreleases()


    /***************************************************************************
    * mut_call_getPressreleasesHeadlines()
    *
    * Desc: Save 'Pressreleases' Headlines to state.
    * Note:
    *
    */
    mut_call_getPressreleasesHeadlines: (state, payload) => {

        let pressreleases = [...payload.pressreleases];


        state.pressreleasesheadlines = pressreleases;

    }, // eo function mut_call_getPressreleasesHeadlines()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Website' - 'Pressreleases'
    ***************************************************************************/
    /***************************************************************************
    * Call: 'actn_call_getPressreleases'
    *
    * Desc: Get List of 'Pressreleases'.
    * Note:
    *
    */
    actn_call_getPressreleases: (context, payload) => {

        Vue.prototype.$vp_m();
        axios.post(CONF_API_BASEURL, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                context.commit('mut_call_getPressreleases', response.data.data);
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();


                // >>> --------------------------
                if (error.response && error.response.data.errors) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: error.response.data.errors[0].message
                    });
                } else {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: "Service not available"
                    });
                }
            });

    }, // eo funtion actn_call_getPressreleases()


    /***************************************************************************
    * Call: 'actn_call_getPressreleasesHeadlines'
    *
    * Desc: Get List of 'Pressreleases' Headlines (for Footer).
    * Note:
    *
    */
    actn_call_getPressreleasesHeadlines: (context, payload) => {

        axios.post(CONF_API_BASEURL, payload)
            .then(function (response) {
                context.commit('mut_call_getPressreleasesHeadlines', response.data.data);
            })
            .catch(function (error) {

                // >>> --------------------------
                if (error.response && error.response.data.errors) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: error.response.data.errors[0].message
                    });
                } else {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: "Service not available"
                    });
                }
            });

    }, // eo funtion actn_call_getPressreleasesHeadlines()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/pressreleases/pressreleases.js